(function () {

  /**
   /**
   * @class ute-ui.extras
   * @memberOf ute-ui
   * @name uteAddressComplete
   * @description
   *   Canada Post address auto completion in an input tag
   *   Requirements;
   *
   *   Input/Configuration/Parameter;
   *     1. MUST load required .js and .css automatically, so that user does not have to deal with these files
   *     2. MUST be able to specify license `key` as attribute or configuration.
   *     3. MUST be able to specify language as attribute or configuration.
   *
   *   Output;
   *     1. MUST be able to call callback function when the final address is populated
   *     2. BETTER to be able to call callback function when the address is not found
   *
   *   Restrict To:
   *     Attribute
   *
   * @param {String} key
   *    Canada post license key, if not defined it uses hard-coded license key, i.e. 'JJ22-BF18-BM96-CT77'
   * @param {String} locale
   *    Language preference for all messages and labels.  i.e. 'en-us', 'fr-ca'
   * @param {String} callback
   *    The callback function called when address is determined(pupulated). i.e. 'myCallback'
   * @param {String} callback-not-found
   *    The callback function called when address cannot be determined
   * @param {String} callback-error
   *    The callback function called when there is error
   * @example
   * Usage:
   *   <input ute-address-complete key='<<LICENSE-KEY>>'
   *     locale='<<LOCALE>>' callback='<<CALLBACK>>' callback-not-found='<<NOTFOUND>>' callback-error='<<ERROR>>' />
   *
   * Example:
   *    <script>
   *     app.controller('MyCtrl', function($scope) {
   *       $scope.processAddress = function(address) {
   *         $scope.address = address;
   *         $scope.$apply();
   *       };
   *       $scope.processNotFound = function() {
   *         console.log('no address is found');
   *       };
   *       $scope.processError = function(e) {
   *         console.log('there is error', e);
   *       };
   *     });
   *    </script>
   *    <div ng-controller='MyCtrl'>
   *      Address: <br/>
   *      <input ute-address-complete  key='AA11-BB22-CC33-DD44' locale='en-ca'
   *         callback='processAddress'
   *         callback-not-found='processNotFound'
   *         callback-error='processError'
   *         size=60 /> <br/>
   *    </div>
   */

  'use strict';

  /*global pca:false */

  angular.module('ute.ui')

    .directive('uteAddressComplete', ['AddressCompleteService', '$timeout', function (addressCompleteService, $timeout) {
      return {
        restrict: 'EA',
        controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {

          $scope.lazyLoaded = function () {

            // on success load; fire off configuration;
            var fields = [{
              element: $element[0],
              field: 'Label'
            }];
            try {
              var control = new pca.Address(fields, {
                key: $attrs.key || 'JJ22-BF18-BM96-CT77',
                culture: $attrs.locale || 'en-us',
                advancedFields: [
                  '{StreetNumber}',
                  '{StreetName}',
                  '{StreetType}',
                  '{StreetDirection}',
                  '{StreetNumberSuffix}',
                  '{StreetPreDirection}',
                  '{StreetPostDirection}'
                ],
                bar: {
                  visible: false,
                  showCountry: false,
                  showLogo: false
                },
                search: {
                  maxResults: 300,
                  maxSuggestions: 50,
                  minItems: 1,
                  maxItems: 10
                }
              });
              control.listen('populate', function (address) {
                $attrs.callback && $scope[$attrs.callback](address);
              });
              control.listen('noresults', function () {
                $attrs.callbackNotFound && $scope[$attrs.callbackNotFound]();
              });

              // if processing object has been passed from the parent
              if ($scope.processing) {
                $scope.processing.loading = false;
              }

              $timeout(function () {
                $scope.$emit('addressCompleteReady');
              }, 0);

              // set autocomplete to 'off'; cp updates this to 'pca' when loaded
              $($element[0]).attr('autocomplete', 'off');
              if ($($element[0]).parents().hasClass("modal-dialog")) {
                $('.pca:first').insertBefore($($element[0]));
                $('.pca:first').addClass('formodal');
              }

            } catch (e) {
              $attrs.callbackError && $scope[$attrs.callbackError](e);
            }

          };

          // lazy load all canadapost files
          // $ocLazyLoad.load([
          //   window.location.protocol + '//ws1.postescanada-canadapost.ca/css/addresscomplete-2.30.min.css',
          //   window.location.protocol + '//ws1.postescanada-canadapost.ca/js/addresscomplete-2.30.min.js'
          // ]).then($scope.lazyLoaded);

          addressCompleteService.load().then(function () {
            $scope.$applyAsync(function () {
              $scope.lazyLoaded();
            });
          });

        }]
      };
    }]);
})();
